import { Backdrop, CircularProgress, Grid, Typography } from "@material-ui/core"
import { useAssets, useAssetsDisposition, useRevokeAssets } from "../../../intake/intakeQueries";
import { Error } from "@material-ui/icons";
import { AssetManegementTable } from "./assetManagementTable";
import { RevokeTable } from "./RevokeTable";

export const RevokeAssetTable = () => {

      const {
        error: errorAsset,
        data: revokeAssets,
        isLoading: isLoadingAsset,
        isError: isErrorAsset,
      } = useRevokeAssets();
      const {
        error: errorAssetDisposition,
        data: assetsDisposition,
        isLoading: isLoadingAssetDisposition,
        isError: isErrorAssetDisposition,
      } = useAssetsDisposition();
    
    
      if (isLoadingAsset || isLoadingAssetDisposition) {
        return (
          <Backdrop open={isLoadingAsset || isLoadingAssetDisposition}>
            <CircularProgress></CircularProgress>
          </Backdrop>
        )
      }
    
      if (isErrorAsset) {
        return (
          <Error></Error>
        )
      }

      
    return (

        <>
        <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={1}
            style={{ marginBottom: 15 }}
        >

            <Grid item xs={4}>
                <Typography variant="h3">Revoke Asset's List</Typography>
            </Grid>
        </Grid>

        <RevokeTable assets={revokeAssets} assetDisposition={assetsDisposition} />

        </>
    )
}